import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { reactive, onMounted, toRefs } from "vue";
import apis from "@/api";
import { useRouter } from "vue-router";
export default {
  components: {},
  setup() {
    const router = useRouter();
    onMounted(() => {
      loadData();
    });
    let data = reactive({
      msgList: [{
        auditSttts: []
      }]
    });
    const loadData = () => {
      let params = {
        pageNo: 1,
        pageSize: 7,
        count: 1
      };
      apis.getBacklog(params).then(res => {
        if (res.success) {
          var _res$data$records;
          data.msgList = (_res$data$records = res.data.records) !== null && _res$data$records !== void 0 ? _res$data$records : [];
          // 根据需求id查找该需求审核情况
          data.msgList.forEach(function (item, index) {
            if (item.name === '短信素材审核' || item.name === '设计素材审核') {
              apis.getAuditSttts({
                demandId: item.demandId
              }).then(response => {
                if (response.success) {
                  data.msgList[index].auditSttts = response.data;
                } else {
                  ElMessage.error(response.msg);
                }
              });
            }
          });
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const handleFinish = index => {
      apis.updateBacklogById({
        id: data.msgList[index].id
      });
      if (data.msgList[index].router) {
        router.push(JSON.parse(data.msgList[index].router));
      }
    };
    return {
      ...toRefs(data),
      loadData,
      handleFinish
    };
  }
};